import TransactionModal from "./transactionModal.js";
import { $_GET } from "../globalFunctions.js";

export default class ValuationModal extends TransactionModal {
  constructor(companyId) {
    super("valuation-modal", companyId);

    this.$valuation = this.$form.querySelector('[name="valuation"]');
    this.$price = this.$form.querySelector('[name="price"]');

    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "name",
        varType: "string",
        required: true,
      },
      {
        name: "date",
        varType: "string",
        required: true,
        trigger: "change",
      },
      {
        name: "price",
        varType: "float",
      },
      {
        name: "valuation_type",
        varType: "int",
        required: true,
      },
      {
        name: "public",
        fieldType: "checkbox",
        required: true,
      },
      {
        name: "documents",
        varType: "simple-array",
        type: "int",
      },
      {
        name: "notes",
      },
    ];

    this.setupForm();

    Promise.all([this.documentsPromise, this.getSharesCount()]).then(
      (result) => {
        this.totalShares = result[1];
        this.whenReady();
      }
    );
  }

  setupForm() {
    const $date = this.$form.querySelector('[name="date"]');
    $date.valueAsDate = new Date();

    this.$valuation.addEventListener("input", () => {
      const pps = this.toFixedNumber(
        this.getFloat("valuation") / this.totalShares,
        6
      );
      if (pps > 0) {
        this.setFloat("price", pps);
      }
    });

    this.$price.addEventListener("input", () => {
      const valuation = this.toFixedNumber(
        this.getFloat("price") * this.totalShares,
        2
      );
      if (valuation > 0) {
        this.setFloat("valuation", valuation);
      }
    });

    $date.addEventListener("change", () => {
      this.getSharesCount().then((count) => {
        this.totalShares = count;
      });
    });
  }

  getSharesCount() {
    return new Promise((resolve, reject) => {
      peque
        .api(
          "shares/count",
          {
            company: this.companyId,
            simulation: $_GET("simulation"),
            date: this.getString("date"),
          },
          "get"
        )
        .then((response) => {
          resolve(response.result ? response.result.total : 0);
        });
    });
  }

  toFixedNumber(number, digits, base) {
    const pow = Math.pow(base || 10, digits);
    return Math.round(number * pow) / pow;
  }

  validateAndSendForm() {
    this.getFields(this.formFields)
      .then((data) => {
        data.company = this.companyId;
        data.simulation =
          typeof window.pequeData.simulation === "undefined"
            ? $_GET("simulation")
            : window.pequeData.simulation;
        data.type = peque.TRANSACTION_TYPE_VALUATION;

        peque
          .api("transactions", JSON.stringify(data), "post")
          .then((response) => {
            if (response.error > 0) {
              return;
            }
            this.mutateReactTransactions();
          })
          .catch((error) => {
            switch (error.error) {
              case peque.ERROR_DUPLICATED_ENTRY:
                this.showErrorOnField(
                  "Name already in use",
                  this.$form.querySelector('[name="name"]')
                );
                break;
              case peque.ERROR_TWO_VALUATIONS_IN_SAME_DAY:
                this.showErrorOnField(
                  trans("two_valuations_same_day"),
                  this.$form.querySelector('[name="date"]')
                );
                break;
            }
          });
      })
      .catch((error) => {
        if (typeof error.el === "undefined") {
          throw error;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
